export default __webpack_public_path__ + "static/media/flux.ef1c731a.svg";